/*!
  Elysian, by Koding Themes
  elysian-animations.js.liquid
*/

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, ScrollSmoother);
let globalAnimation = {
  siteLoading: function() {
    if (document.querySelector(".timeline-loader") != null) {
      var select = function(s) {
          return document.querySelector(s);
        },
        selectAll = function(s) {
          return document.querySelectorAll(s);
        };
      var loader = select('.timeline-loader .loader');
      var dots = selectAll('.timeline-loader .dot');
      var tl = gsap.timeline({
        repeat: 5,
        repeatDelay: 0.3
      });
      tl.staggerFrom(dots, 1, {
        autoAlpha: 0,
        scale: 0.1,
        ease: Elastic.easeOut
      }, 0.2).staggerTo(dots, 0.1, {
        backgroundColor: ''
      }, 0.1, '-=0.7').to(loader, 0.2, {
        autoAlpha: 0,
        scale: 0
      });
      gsap.to('.timeline-loader', {
        autoAlpha: 0,
        delay: 3,
        duration: 1,
        ease: Power4.easeOut
      });
    }
  },
 animationEffects: function(e) {
    // 7 - Entire site scroll
    ScrollTrigger.matchMedia({
      "(min-width: 768px)": function() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
        ScrollSmoother.create({
          content: ".main-container",
          smooth: 2,
          effects: false,
          smoothTouch: 1.5,
        });
       }
      });

    //animate sections
    if (document.body.getAttribute("id") != "product") {
      if (document.body.getAttribute("id") != "collection") {
        var shopifySections = gsap.utils.toArray(".shopify-section");
        if (shopifySections != null) {
          gsap.set(".shopify-section", {
            clearProps: true
          });
          gsap.set(shopifySections, {
            className: "animation-applied-element",
          });
          shopifySections.forEach((sectionItem, i) => {
            if (sectionItem.querySelector("header") == null && sectionItem.querySelector(".main-footer") == null) {
              ScrollTrigger.matchMedia({
                "(min-width: 768px)": function() {
                  var anim1 = gsap.fromTo(sectionItem, {
                    autoAlpha: 0,
                    y: 150,
                  }, {
                    duration: 1,
                    autoAlpha: 1,
                    y: 0,
                  });
                  ScrollTrigger.create({
                    trigger: sectionItem,
                    animation: anim1,
                    start: "top 100%",
                    end: "top 50%",
                    markers: false,
                    scrub: 1.5,
                  });
                },
              });
            }
          });
        }
      }
    }
    // product page scroll effect media
    if (document.body.getAttribute("id") == "product") {
      // scrolltrigger for each section
      var sections = gsap.utils.toArray(".shopify-section");
      if (sections != null) {
        gsap.set(".shopify-section", {
          clearProps: true
        });
        sections.forEach((section, i) => {
          if (section.querySelector("#product-form") == null && section.querySelector(".shopify-section-group-footer-group") != null && section.querySelector("header") == null) {
            var anim = gsap.fromTo(section, {
              autoAlpha: 0,
              y: 150,
            }, {
              duration: 1,
              autoAlpha: 1,
              y: 0,
            });
            ScrollTrigger.create({
              trigger: section,
              animation: anim,
              start: "top 100%",
              end: "top 60%",
              markers: false,
              scrub: 1.5,
            });
          }
        });
      }
    }
  },
 defaultAnimationEffects: function(e){
   // flicker debugger
    window.addEventListener("load", (event) => {
      var flickerSelectors = ['.main-sidebar', '.desktop-sidebar-menu', '.collection-sorting.filter-wrapper', '#product-info', '.product-grid', '#page-cart'];
      flickerSelectors.forEach(function(sl, index) {
        var item = document.querySelector(sl);
        console.log("loading js", item);
        if (item != null) {
          // item.style.setProperty("will-change", "transform, opacity");
        }
      });
    });
    window.addEventListener("load", (event) => {
      var productImgDsk = [".product-media-desktop-only"];
      productImgDsk.forEach(function(item, index) {
        var productItem = document.querySelector(item);
        console.log("loading js", productItem);
        if (productItem != null) {
          productItem.style.setProperty("will-change", "transform, opacity");
        }
      });
    });
   // 8 - Marquee text effect
    var marquees = document.querySelectorAll('.main-logo-slides');
    if (marquees.length > 0) {
      marquees.forEach(function(marquee) {
        var marqueeWrapper = marquee.closest('.scrolling-cta-wrapper');
        var links = marquee.querySelectorAll(".main-logo-slide");
        if (links.length > 0) {
          // assign the timeline returned from the helper function to 'loop'
          let loop = horizontalLoop(links, {
            repeat: -1,
            speed: 1 + 0.5,
            draggable: true,
            reversed: false,
            paddingRight: parseFloat(gsap.getProperty(links[0], "marginRight", "px"))
          });
          // handle the timeline on hover
          if (marqueeWrapper != null) {
            marquee.addEventListener("mouseenter", () => {
              loop.pause()
            });
            marquee.addEventListener("mouseleave", () => {
              loop.play()
            });
          }
          // handle the timeline on scroll
          let currentScroll = 0;
          let scrollDirection = 1;
          window.addEventListener("scroll", () => {
            let direction = window.pageYOffset > currentScroll ? 1 : -1;
            if (direction !== scrollDirection) {
              gsap.to(loop, {
                timeScale: direction,
                overwrite: true
              });
              scrollDirection = direction;
            }
            currentScroll = window.pageYOffset;
          });
        }
      });
    }

    function horizontalLoop(items, config) {
      if (items[0] != null) {
        items = gsap.utils.toArray(items);
        config = config || {};
        let tl = gsap.timeline({
            repeat: config.repeat,
            paused: config.paused,
            defaults: {
              ease: "none"
            },
            onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
          }),
          length = items.length,
          startX = items[0].offsetLeft,
          times = [],
          widths = [],
          xPercents = [],
          curIndex = 0,
          pixelsPerSecond = (config.speed || 1) * 100,
          snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
          populateWidths = () => items.forEach((el, i) => {
            widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
            xPercents[i] = snap(
              (parseFloat(gsap.getProperty(el, "x", "px")) / widths[i]) * 100 + gsap.getProperty(el, "xPercent"));
          }),
          getTotalWidth = () => items[length - 1].offsetLeft + (xPercents[length - 1] / 100) * widths[length - 1] - startX + items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], "scaleX") + (parseFloat(config.paddingRight) || 0),
          totalWidth,
          curX,
          distanceToStart,
          distanceToLoop,
          item,
          i;
        populateWidths();
        gsap.set(items, {
          // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
          xPercent: (i) => xPercents[i]
        });
        gsap.set(items, {
          x: 0
        });
        totalWidth = getTotalWidth();
        for (i = 0; i < length; i++) {
          item = items[i];
          curX = (xPercents[i] / 100) * widths[i];
          distanceToStart = item.offsetLeft + curX - startX;
          distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
          tl.to(item, {
            xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
            duration: distanceToLoop / pixelsPerSecond
          }, 0).fromTo(item, {
            xPercent: snap(
              ((curX - distanceToLoop + totalWidth) / widths[i]) * 100)
          }, {
            xPercent: xPercents[i],
            duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
            immediateRender: false
          }, distanceToLoop / pixelsPerSecond).add("label" + i, distanceToStart / pixelsPerSecond);
          times[i] = distanceToStart / pixelsPerSecond;
        }

        function toIndex(index, vars) {
          vars = vars || {};
          Math.abs(index - curIndex) > length / 2 && (index += index > curIndex ? -length : length); // always go in the shortest direction
          let newIndex = gsap.utils.wrap(0, length, index),
            time = times[newIndex];
          if (time > tl.time() !== index > curIndex) {
            // if we're wrapping the timeline's playhead, make the proper adjustments
            vars.modifiers = {
              time: gsap.utils.wrap(0, tl.duration())
            };
            time += tl.duration() * (index > curIndex ? 1 : -1);
          }
          curIndex = newIndex;
          vars.overwrite = true;
          return tl.tweenTo(time, vars);
        }
        tl.next = (vars) => toIndex(curIndex + 1, vars);
        tl.previous = (vars) => toIndex(curIndex - 1, vars);
        tl.current = () => curIndex;
        tl.toIndex = (index, vars) => toIndex(index, vars);
        tl.updateIndex = () => (curIndex = Math.round(tl.progress() * (items.length - 1)));
        tl.times = times;
        tl.progress(1, true).progress(0, true); // pre-render for performance
        if (config.reversed) {
          tl.vars.onReverseComplete();
          tl.reverse();
        }
        if (config.draggable && typeof Draggable === "function") {
          let proxy = document.createElement("div"),
            wrap = gsap.utils.wrap(0, 1),
            ratio,
            startProgress,
            draggable,
            dragSnap,
            roundFactor,
            align = () => tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio)),
            syncIndex = () => tl.updateIndex();
          typeof InertiaPlugin === "undefined" && console.warn("InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club");
          draggable = Draggable.create(proxy, {
            trigger: items[0].parentNode,
            type: "x",
            onPress() {
              startProgress = tl.progress();
              tl.progress(0);
              populateWidths();
              totalWidth = getTotalWidth();
              ratio = 1 / totalWidth;
              dragSnap = totalWidth / items.length;
              roundFactor = Math.pow(10, ((dragSnap + "").split(".")[1] || "").length);
              tl.progress(startProgress);
            },
            onDrag: align,
            onThrowUpdate: align,
            inertia: true,
            snap: (value) => {
              let n = Math.round(parseFloat(value) / dragSnap) * dragSnap * roundFactor;
              return (n - (n % 1)) / roundFactor;
            },
            onRelease: syncIndex,
            onThrowComplete: () => gsap.set(proxy, {
              x: 0
            }) && syncIndex()
          })[0];
        }
        return tl;
      }
    }
 },
 init: function(e) {
    globalAnimation.defaultAnimationEffects(e);
    
      globalAnimation.animationEffects(e);
    
 }
};
if (Shopify.designMode != true) {
  document.addEventListener("DOMContentLoaded", function(e) {
    globalAnimation.init(e);
    globalAnimation.siteLoading();
  });
  document.addEventListener("shopify:section:load", function(e) {
    globalAnimation.init(e);
    globalAnimation.siteLoading();
  });
  document.addEventListener("shopify:section:unload", function(e) {
    globalAnimation.init(e);
  });
  document.addEventListener("shopify:section:reorder", function(e) {
    globalAnimation.init(e);
    globalAnimation.siteLoading();
  });
  document.addEventListener("DOMContentLoaded", function() {
    var checkbox = document.querySelector(".RecipientCheckbox");
    if (checkbox != null) {
      checkbox.addEventListener("click", function(e) {
        globalAnimation.init(e);
        sectionAnimation.productMediaWithSticky(e);
      });
    }
  });
}
if (Shopify.designMode == true) {
  globalAnimation.siteLoading();
  var infoWrapWidth = 400;
  document.onscroll = function() {
    if (document.querySelector("#product-info") != null) {
     infoWrapWidth = document.querySelector("#product-info").offsetWidth;
    }
     stickyProductMediaSection(infoWrapWidth);
  };
  window.onresize = function() {
    if (document.querySelector("#product-info") != null) {
      infoWrapWidth = document.querySelector("#product-info").offsetWidth;
    }
     stickyProductMediaSection(infoWrapWidth);
  };

  function stickyProductMediaSection(infoWrapWidth) {
    var mediaWrap = document.querySelector("#product-media");
    var infoWrap = document.querySelector("#product-info");
    if (mediaWrap != null && infoWrap != null) {
      var row = infoWrap.closest(".product-overview");
      if (window.innerWidth > 767) {
        var hm = mediaWrap.offsetHeight;
        var hi = infoWrap.offsetHeight;
        var diffmi = hm - hi;
        if (hm > hi) {
          infoWrap.style.position = "fixed";
          infoWrap.style.setProperty("width", infoWrapWidth + "px", "");
          var rect = mediaWrap.getBoundingClientRect();
          var scrolledMedia = -rect.top;
          console.log('scrolledMedia, diffmi',scrolledMedia, diffmi);
          if (scrolledMedia >= diffmi) {
            infoWrap.style.position = "relative";
            row.style.setProperty("align-self", "end", "");
            infoWrap.style.removeProperty("top");
          } else if (scrolledMedia < diffmi) {
            infoWrap.style.position = "fixed";
            row.style.removeProperty("align-self");
            infoWrap.style.setProperty("top", "0", "");
          }
          if (Math.sign(scrolledMedia) == -1) {
            infoWrap.style.position = "relative";
            row.style.removeProperty("align-self");
            infoWrap.style.removeProperty("top");
            infoWrap.style.removeProperty("width");
          }
        }
      } else {
        infoWrap.style.position = "relative";
        row.style.removeProperty("align-self");
        infoWrap.style.removeProperty("top");
        infoWrap.style.removeProperty("width");
      }
    }
  }
}
let sectionAnimation = {
  productMediaWithSticky: function(e){
    // product page scroll effect media
    if (document.body.getAttribute("id") == "product") {
      var addHeight = 0;
      if (e.type == "shopify:section:load") {
        addHeight = document.querySelector("#product-info").offsetHeight;
      }
      if (e.type == "click") {
        addHeight = document.querySelector("#product-info").offsetHeight;
      }
      gsap.set("#product-media", {
        clearProps: true
      });
      gsap.set("#product-info", {
        clearProps: true
      });
      ScrollTrigger.matchMedia({
        "(min-width: 768px)": function() {
          var section = document.querySelector("#product-media");
          var anim = gsap.fromTo(section, {
            y: 0,
          }, {
            duration: 0.5,
            y: 0,
            ease: "power4.out",
          });
          ScrollTrigger.create({
            trigger: section,
            animation: anim,
            top: "top 0%",
            end: (self) => "+=" + (document.querySelector("#product-media").offsetHeight - addHeight - self.pin.offsetHeight),
            pin: "#product-info",
            onRefresh: (self) => (self.pin.parentNode.style.float = "left"),
            pinSpacing: false,
            anticipatePin: 1,
            markers: false,
            scrub: 2,
          });
        },
     });
    }
  },
  parallaxScrolling: function() {
    // parallax background section animation
    var parallaxWrp = document.querySelectorAll('.main-parallax-animation');
    var startAnim = "top+=40% 100%";
    if (Shopify.designMode == true) {
      startAnim = "top+=50% 100%";
    }
    if (parallaxWrp.length > 0) {
      parallaxWrp.forEach(function(parallax) {
        var sectionID = parallax.getAttribute('id');
        if(document.querySelector('.main-parallax-animation-body-'+sectionID) == null){
          var bodyEl = document.createElement("div");
          bodyEl.classList.add('main-parallax-animation-body-'+sectionID);
          bodyEl.classList.add('main-parallax-animation-body-wrp');
          var s = document.body.firstChild;
          s.parentNode.insertBefore(bodyEl, s);

        var tl = gsap.timeline({
          duration: 0.1,
          scrollTrigger: {
            trigger: parallax,
            start: startAnim,
            end: 'bottom center-=100px',
            scrub: true,
            markers: false,
            toggleClass: { targets: bodyEl, className: 'main-parallax-animation-body-inner-'+sectionID },
          }
        });
        tl.fromTo(bodyEl, {
          opacity: 0,
        }, {
          opacity: 1,
          duration: 1,
        })
        tl.fromTo(bodyEl, {
          opacity: 1,
        }, {
          opacity: 0,
        }, 3)
       }
      });
    }
  },
  mainSlider: function() {
    
    // slider section animation
    var slidersWrp = document.querySelectorAll('.main-slideshow-wrp'); //inner
    var headerHeight = 0;
    if(document.querySelector('header.main-header') != null) {
      headerHeight = document.querySelector('header.main-header').clientHeight;
    }
    var heightTop = '60px';
    if(headerHeight == 0){
        heightTop = '10px';
    }

    if (slidersWrp.length > 0) {
      slidersWrp.forEach(function(sliderWrp) {
        var tl = gsap.timeline({
          duration: 0.1,
          scrollTrigger: {
            trigger: sliderWrp,
            start: "top+=20px "+heightTop,
            end: "top top+=200px",
            scrub: 1,
            markers: false,
            id: "points",
          }
        });
        // tl.set(sliderWrp, {
        //  className: "image-slider inner main-slideshow-wrp py-3 main-slideshow-wrp-height"
        // });
        var innerCards = sliderWrp.querySelectorAll('.card-site-anime');
        tl.fromTo(innerCards, {scale: 1 }, {scale: 0.97});
        if (innerCards.length > 0) {
          innerCards.forEach(function(innerCard) {
            tl.to(innerCard, {
              borderRadius: 'var(--rounded-large)'
            }, 0.5)
            var sectionOverlay = innerCard.querySelector('.section-overlay');
            if (sectionOverlay != null) {
              tl.set(sectionOverlay, {
                className: "section-overlay rounded__all"
              });
            }
          });
        }
      });
    }
   
  },
  productSlider: function(e) {
    // Marquee for product slider
    var marquees = document.querySelectorAll('.product-slider-list');
    if (marquees.length > 0) {
      marquees.forEach(function(marquee) {
        var marqueeWrapper = marquee.closest('.main-product-slider-wrp-main');
        var links = marquee.querySelectorAll(".product-slider-block");
        console.log('marqueeWrapper', marqueeWrapper);
        console.log('links', links);
        if (links.length > 0) {
          // assign the timeline returned from the helper function to 'loop'
          let loop = horizontalLoopSlider(links, {
            repeat: -1,
            speed: 1 + 0.5,
            draggable: true,
            reversed: false,
            paddingRight: parseFloat(gsap.getProperty(links[0], "marginRight", "15px"))
          });
          // handle the timeline on hover
          if (marqueeWrapper != null) {
            marquee.addEventListener("mouseenter", () => {
              loop.pause()
            });
            marquee.addEventListener("mouseleave", () => {
              loop.play()
            });
          }
          // handle the timeline on scroll
          let currentScroll = 0;
          let scrollDirection = 1;
          window.addEventListener("scroll", () => {
            let direction = window.pageYOffset > currentScroll ? 1 : -1;
            if (direction !== scrollDirection) {
              gsap.to(loop, {
                timeScale: direction,
                overwrite: true
              });
              scrollDirection = direction;
            }
            currentScroll = window.pageYOffset;
          });
        }
      });
    }

    function horizontalLoopSlider(items, config) {
      if (items[0] != null) {
        items = gsap.utils.toArray(items);
        config = config || {};
        let tl = gsap.timeline({
            repeat: config.repeat,
            paused: config.paused,
            defaults: {
              ease: "none"
            },
            onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
          }),
          length = items.length,
          startX = items[0].offsetLeft,
          times = [],
          widths = [],
          xPercents = [],
          curIndex = 0,
          pixelsPerSecond = (config.speed || 1) * 100,
          snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
          populateWidths = () => items.forEach((el, i) => {
            widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
            xPercents[i] = snap(
              (parseFloat(gsap.getProperty(el, "x", "px")) / widths[i]) * 100 + gsap.getProperty(el, "xPercent"));
          }),
          getTotalWidth = () => items[length - 1].offsetLeft + (xPercents[length - 1] / 100) * widths[length - 1] - startX + items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], "scaleX") + (parseFloat(config.paddingRight) || 0),
          totalWidth,
          curX,
          distanceToStart,
          distanceToLoop,
          item,
          i;
        populateWidths();
        gsap.set(items, {
          // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
          xPercent: (i) => xPercents[i]
        });
        gsap.set(items, {
          x: 0
        });
        totalWidth = getTotalWidth();
        for (i = 0; i < length; i++) {
          item = items[i];
          curX = (xPercents[i] / 100) * widths[i];
          distanceToStart = item.offsetLeft + curX - startX;
          distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
          tl.to(item, {
            xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
            duration: distanceToLoop / pixelsPerSecond
          }, 0).fromTo(item, {
            xPercent: snap(
              ((curX - distanceToLoop + totalWidth) / widths[i]) * 100)
          }, {
            xPercent: xPercents[i],
            duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
            immediateRender: false
          }, distanceToLoop / pixelsPerSecond).add("label" + i, distanceToStart / pixelsPerSecond);
          times[i] = distanceToStart / pixelsPerSecond;
        }

        function toIndex(index, vars) {
          vars = vars || {};
          Math.abs(index - curIndex) > length / 2 && (index += index > curIndex ? -length : length); // always go in the shortest direction
          let newIndex = gsap.utils.wrap(0, length, index),
            time = times[newIndex];
          if (time > tl.time() !== index > curIndex) {
            // if we're wrapping the timeline's playhead, make the proper adjustments
            vars.modifiers = {
              time: gsap.utils.wrap(0, tl.duration())
            };
            time += tl.duration() * (index > curIndex ? 1 : -1);
          }
          curIndex = newIndex;
          vars.overwrite = true;
          return tl.tweenTo(time, vars);
        }
        tl.next = (vars) => toIndex(curIndex + 1, vars);
        tl.previous = (vars) => toIndex(curIndex - 1, vars);
        tl.current = () => curIndex;
        tl.toIndex = (index, vars) => toIndex(index, vars);
        tl.updateIndex = () => (curIndex = Math.round(tl.progress() * (items.length - 1)));
        tl.times = times;
        tl.progress(1, true).progress(0, true); // pre-render for performance
        if (config.reversed) {
          tl.vars.onReverseComplete();
          tl.reverse();
        }
        if (config.draggable && typeof Draggable === "function") {
          let proxy = document.createElement("div"),
            wrap = gsap.utils.wrap(0, 1),
            ratio,
            startProgress,
            draggable,
            dragSnap,
            roundFactor,
            align = () => tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio)),
            syncIndex = () => tl.updateIndex();
          typeof InertiaPlugin === "undefined" && console.warn("InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club");
          draggable = Draggable.create(proxy, {
            trigger: items[0].parentNode,
            type: "x",
            onPress() {
              startProgress = tl.progress();
              tl.progress(0);
              populateWidths();
              totalWidth = getTotalWidth();
              ratio = 1 / totalWidth;
              dragSnap = totalWidth / items.length;
              roundFactor = Math.pow(10, ((dragSnap + "").split(".")[1] || "").length);
              tl.progress(startProgress);
            },
            onDrag: align,
            onThrowUpdate: align,
            inertia: true,
            snap: (value) => {
              let n = Math.round(parseFloat(value) / dragSnap) * dragSnap * roundFactor;
              return (n - (n % 1)) / roundFactor;
            },
            onRelease: syncIndex,
            onThrowComplete: () => gsap.set(proxy, {
              x: 0
            }) && syncIndex()
          })[0];
        }
        return tl;
      }
    }
  },
  sidebarMenu: function(e) {
    
   if (Shopify.designMode != true) {
   if (document.querySelector(".main-container") != null && document.querySelector(".main-sidebar") != null) {
      ScrollTrigger.matchMedia({
        "(min-width: 1008px)": function() {
          gsap.set(".main-container", {
            clearProps: true
          });
          gsap.set(".main-sidebar", {
            clearProps: true
          });
          let triggers = ScrollTrigger.getAll();
          triggers.forEach((trigger) => {
            var triggers = trigger.vars.trigger;
            if (triggers == ".main-container") {
              trigger.kill();
            }
          });
          gsap.set(".main-sidebar .left-side", {
            // x: 0
          });

          ScrollTrigger.create({
            trigger: ".main-container",
            start: "top top",
            pin: ".main-sidebar",
            anticipatePin: 1,
            normalizeScroll: true,
            pinSpacing: false,
          });
          ScrollTrigger.create({
            trigger: ".main-container",
            start: "top top",
            pin: ".desktop-sidebar-menu",
            anticipatePin: 1,
            normalizeScroll: true,
            pinSpacing: false,
          });
          if(document.querySelector(".floating-menu-button-wrapper") != null){
            ScrollTrigger.create({
              trigger: ".main-container",
              start: "top top",
              pin: ".floating-menu-button-wrapper",
              anticipatePin: 1,
              normalizeScroll: true,
              pinSpacing: false,
            });
          }
        },
      });
      var pinEl = document.querySelector(".main-sidebar").closest('.pin-spacer');
      if (pinEl != null) {
        pinEl.classList.add('main-sidebar-pin');
      }
      var pinElM = document.querySelector(".desktop-sidebar-menu").closest('.pin-spacer');
      if (pinElM != null) {
        pinElM.classList.add('main-sidebar-menu-pin');
      }
      if(document.querySelector(".floating-menu-button-wrapper") != null){
        var pinElMFL = document.querySelector(".floating-menu-button-wrapper").closest('.pin-spacer');
        if (pinElMFL != null) {
          pinElMFL.classList.add('floating-menu-button-pin');
        }
      }
    }
   }
    
    var parallaxSections = document.querySelectorAll('.main-parallax-animation-body-wrp');
    var searchModal = document.querySelector('.search-modal-content-inner');
     if(window.innerWidth > 1007) {
      var docWidth = document.documentElement.clientWidth || document.body.clientWidth;
      var fullWidth = window.innerWidth;
      var diff = fullWidth - docWidth;
      //console.log('diff,fullWidth,docWidth',diff,fullWidth,docWidth);
      var containerMain = document.querySelector('.main-container');
      var sidebarMain = document.querySelector(".main-sidebar .left-side");
      var menuMain = document.querySelector(".desktop-sidebar-menu-wrp");

      if(containerMain != null && sidebarMain != null && menuMain != null) {
        var sidebarMainW = sidebarMain.offsetWidth;
        var menuMainW = menuMain.offsetWidth;
        if(document.querySelector("body.active-menu") == null){
          menuMainW = 0;
        }
        var reduceContainerBy = diff + sidebarMainW + menuMainW;
        if(menuMainW == 0){
          //containerMain.style.setProperty("grid-template-columns", menuMainW+'px calc(100% - '+reduceContainerBy+'px) '+sidebarMainW+'px');
        } else {
          //containerMain.style.setProperty("grid-template-columns", menuMainW+'px calc(100% - '+reduceContainerBy+'px) '+sidebarMainW+'px');
        }


        reduceContainerBy = sidebarMainW + menuMainW;
        //if(searchModal != null){searchModal.style.setProperty("max-width", 'calc(50vw - '+sidebarMainW+'px)');}
        //if(searchModal != null){searchModal.style.setProperty("left", menuMainW+'px');}

        if(parallaxSections.length > 0) {
         parallaxSections.forEach(function(parallaxSection){
           // parallaxSection.style.setProperty("width", 'calc(100% - '+reduceContainerBy+'px)');
           // parallaxSection.style.setProperty("left", menuMainW+'px');
         });
       }

        if (Shopify.designMode != true) {
          if(menuMainW == 0){
            //containerMain.style.setProperty("grid-template-columns", menuMainW+'px calc(100% - '+reduceContainerBy+'px) '+sidebarMainW+'px');
          } else {
            //containerMain.style.setProperty("grid-template-columns", menuMainW+'px calc(100% - '+reduceContainerBy+'px) '+sidebarMainW+'px');
          }
          
           sidebarMain.style.setProperty("right", '-'+(2*sidebarMainW)+'px');
          
        }
      }
    } else {
       //if(searchModal != null){searchModal.style.setProperty("max-width", '50vw');}
       //if(searchModal != null){searchModal.style.setProperty("left", '0');}
       if(parallaxSections.length > 0) {
         parallaxSections.forEach(function(parallaxSection){
           parallaxSection.style.setProperty("width", '100%');
           parallaxSection.style.setProperty("left", '0');
         });
       }
    }

  },
  cardsAnimation: function(e){
    
    if(document.querySelector('.collection-page') != null){
      gsap.set(".product-card-item", {opacity: 0});
      gsap.set(".product-card-item", {willChange: 'transform'});
      ScrollTrigger.batch(".product-card-item", {
        onEnter: batch => gsap.to(batch, {autoAlpha: 1, stagger: 0.2}),
        onLeave: batch => gsap.to(batch, {autoAlpha: 0, stagger: 0.2}),
        onEnterBack: batch => gsap.to(batch, {autoAlpha: 1, stagger: 0.2}),
        onLeaveBack: batch => gsap.to(batch, {autoAlpha: 0, stagger: 0.2}),
        markers: false,
        start: 'top 85%',
      });
      ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".product-card-item", {opacity: 0}));
   }
  
  }
};

document.addEventListener("shopify-collection-loader:init-product-grid", function(e) {
  if(document.querySelector('.collection-page') != null){
    var items = document.querySelectorAll('.product-card-item.product-item-loaded');
    if(items.length > 0){
      gsap.set('.product-card-item.product-item-loaded', {opacity: 0});
      gsap.set('.product-card-item.product-item-loaded', {willChange: 'transform'});
      ScrollTrigger.batch('.product-card-item.product-item-loaded', {
        onEnter: batch => gsap.to(batch, {autoAlpha: 1, stagger: 0.2,className:"product-card-item mb-0"}),
        onLeave: batch => gsap.to(batch, {autoAlpha: 0, stagger: 0.2}),
        onEnterBack: batch => gsap.to(batch, {autoAlpha: 1, stagger: 0.2}),
        onLeaveBack: batch => gsap.to(batch, {autoAlpha: 0, stagger: 0.2}),
        markers: false,
        start: 'top 85%',
      });
    }
    sectionAnimation.sidebarMenu();
  }
});

var menuToggle = document.querySelector('.js-menu');
if (menuToggle != null) {
  document.addEventListener("click", function(e) {
    var target = e.target;
    if(target.closest('.js-menu') != null){
     e.preventDefault();
     setTimeout(function(){
      sectionAnimation.sidebarMenu();
     },500);
    }
  });
}

if (Shopify.designMode == undefined) {
var i = 0;
window.addEventListener("scroll", function(e) {
  if(i == 0) {
   sectionAnimation.productMediaWithSticky(e);
    console.log('init productMediaWithSticky');
   i = i + 1;
  }
});
}
document.addEventListener("DOMContentLoaded", function(e) {
  sectionAnimation.productSlider(e);
  sectionAnimation.parallaxScrolling();
  sectionAnimation.mainSlider();
  sectionAnimation.sidebarMenu();
  sectionAnimation.cardsAnimation(e);
});
document.addEventListener("shopify:section:load", function(e) {
  sectionAnimation.productSlider(e);
  sectionAnimation.parallaxScrolling();
  sectionAnimation.mainSlider();
  sectionAnimation.sidebarMenu();
  sectionAnimation.cardsAnimation(e);
});
document.addEventListener("shopify:section:unload", function(e) {
  sectionAnimation.productSlider(e);
  sectionAnimation.parallaxScrolling();
  sectionAnimation.mainSlider();
  sectionAnimation.sidebarMenu();
  sectionAnimation.cardsAnimation(e);
});
document.addEventListener("shopify:section:reorder", function(e) {
  sectionAnimation.productSlider(e);
  sectionAnimation.parallaxScrolling();
  sectionAnimation.mainSlider();
  sectionAnimation.sidebarMenu();
  sectionAnimation.cardsAnimation(e);
});
window.addEventListener("load", function(e) {
  sectionAnimation.productSlider(e);
  sectionAnimation.parallaxScrolling();
  //sectionAnimation.mainSlider();
  sectionAnimation.sidebarMenu();
  //sectionAnimation.cardsAnimation(e);
});
window.addEventListener("resize", function(e) {
  console.log('resizeing new');
  sectionAnimation.parallaxScrolling();
  sectionAnimation.mainSlider();
  setTimeout(function(){
   sectionAnimation.sidebarMenu();
  },0);
  sectionAnimation.cardsAnimation(e);
});
